import { BrowserRouter } from "react-router-dom";
import "./App.css";
import { AuthProvider, useAuth } from "./user/context/AuthContext";
import { AppRoutes } from "./routes";
import { PublicRoutes } from "./routes/public/PublicRoutes";
import { SnackbarProvider } from "notistack";

import { HelmetProvider } from "react-helmet-async";
import "antd/dist/reset.css"

const App = () => {
  return (
    <>
      <HelmetProvider>
        <SnackbarProvider maxSnack={3}>
          <BrowserRouter>
            <AuthProvider>
              <MainLayout />
            </AuthProvider>
          </BrowserRouter>
        </SnackbarProvider>
      </HelmetProvider >
      </>

  );
}
const MainLayout = () => {
  return <LayoutWrapper />;
};


const LayoutWrapper = () => {
  const { isAuthenticated } = useAuth();
  console.log("LayoutWrapper==>", isAuthenticated())
  return isAuthenticated() ? <AppRoutes /> : <PublicRoutes />;
};
export default App;
